import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gamepad2, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Tagline */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <Gamepad2 className="w-4 h-4 text-white" />
              </div>
              <span className="font-display text-lg font-semibold">
                {t('brand')}
              </span>
            </div>
            <p className="text-gray-400 text-sm mb-2">
              {t('footer.tagline')}
            </p>
            <p className="text-gray-500 text-xs">
              {t('footer.availability')}
            </p>
          </div>

          {/* Customer Support */}
          <div>
            <h3 className="font-semibold text-white mb-4">{t('footer.support.title')}</h3>
            <div className="space-y-3">
              <a 
                href={`tel:${t('footer.support.phone')}`}
                className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                {t('footer.support.phone')}
              </a>
              <a 
                href={`mailto:${t('footer.support.email')}`}
                className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                {t('footer.support.email')}
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Links</h3>
            <div className="flex flex-col gap-2 text-sm">
              <a 
                href="/terms.html" 
                className="text-gray-400 hover:text-white transition-colors"
              >
                {t('footer.links.terms')}
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-800 my-8"></div>

        {/* Copyright */}
        <div className="text-center text-gray-500 text-sm">
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
